/**
 * API class
 */
import axios from 'axios'
import Cookies from 'js-cookie'

export function ApiKey() {
  var APIKey = getAPIKey()
  return APIKey
}

function getAPIKey() {
  var key = ''
  //   AIzaSyAXDfHT7HAAt_EZ0mFPGw6sVovzDeNogyM
  if (location.href.includes('localhost')) {
    key = 'AIzaSyARRJy5eO-KF4Ovii349r3PMhBITHKANv0'
  } else if (location.href.includes('staging.backstage.gladmobile.com')) {
    key = 'AIzaSyARRJy5eO-KF4Ovii349r3PMhBITHKANv0'
  } else if (location.href.includes('staging-2.backstage.gladmobile.com')) {
    key = 'AIzaSyBZmEEN1AvjYChnvaG--dIzbnnNwXd1b90'
  } else if (location.href.includes('daisuki.backstage.gladmobile.com')) {
    key = 'AIzaSyBZmEEN1AvjYChnvaG--dIzbnnNwXd1b90'
  } else if (location.href.includes('backstage.gladmobile.com')) {
    key = 'AIzaSyBZmEEN1AvjYChnvaG--dIzbnnNwXd1b90' // glad帳號
  } else {
    key = 'AIzaSyARRJy5eO-KF4Ovii349r3PMhBITHKANv0'
  } //
  return key
}



// WEBPACK FOOTER //
// ./src/assets/js/libs/GoogleAPI.js